import commonDialog from "./common-center-dialog.vue";
const commonCenterDialog = {
  install: function (Vue) {
    Vue.component("common-center-dialog", commonDialog);
  },
};
// 导出该组件
export default commonCenterDialog;
